import { useMemo } from 'react'
import useLoyaltyConfig from 'loyalty/hooks/useLoyaltyConfig'
import type { LoyaltyLandingPageBenefitCopy } from 'loyalty/pages/LoyaltyLandingPageData'
import { getLoyaltyLandingPageBenefitCopy } from 'loyalty/pages/LoyaltyLandingPageData'

function useLoyaltyLandingPageBenefitCopy(): [LoyaltyLandingPageBenefitCopy | undefined, boolean, any] {
  const [config, configFetching, configError] = useLoyaltyConfig()

  const landingPageBenefitCopy = useMemo(() => {
    if (!config) return
    return getLoyaltyLandingPageBenefitCopy(config.regionEnabledBenefits)
  }, [config])

  return [
    landingPageBenefitCopy,
    !!configFetching,
    configError,
  ]
}

export default useLoyaltyLandingPageBenefitCopy
